module.exports = __webpack_public_path__ + "img/base_divers_avion.be2c2190.svg";